import {isNotEmpty} from "./isNotEmpty";
import {INPUT_AGREE, INPUT_EMAIL} from "../../components/sitePages/TrainingCenter/AppForm/initialInputs";
import {emailInputValidate} from "./emailInputValidate";

export default function (state, t) {
  if (!state.shouldValidate) {
    return state;
  }

  state.isValid = false;

  if (!isNotEmpty(state.value)) {
    return {...state};
  }

  switch (state.name) {
    case INPUT_EMAIL:
      emailInputValidate(state, t);
      return {...state};
  }

  state.isValid = true;
  return {...state};
}
